<label class="{{styles.oy_chekcbox_title}} {{props.indeterminate && styles.indeterminate}}">{{if props.indeterminate}} <input type="checkbox" {{if  props.value && props.value.length === props.info.length}}checked="checked"{{/if}}> {{/if}} <span title="{{props.name}}" class="{{styles.item_content}}">{{props.name | maxLength props.maxTextLength}}:</span></label>


// WEBPACK FOOTER //
// ./D:/project/issts/oy-search-component/src/components/OYCheckbox/indeterminate.art